'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer() {
  return _react2.default.createElement(
    'footer',
    { className: 'Footer' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'institution' },
        'UQAM',
        _react2.default.createElement(
          'span',
          { className: 'fullName' },
          ' - Universit\xE9 du Qu\xE9bec \xE0 Montr\xE9al'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'info' },
        'Calendrier des \xE9v\xE9nements',
        _react2.default.createElement(
          'span',
          { className: 'contact' },
          _react2.default.createElement(_caligramReact.Icon, { name: 'chevronRight' }),
          _react2.default.createElement(
            'a',
            { href: 'mailto:evenements@uqam.ca' },
            'evenements@uqam.ca'
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.js
// module id = 1115
// module chunks = 0